<app-spinner></app-spinner>
<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-auto">
                <h1 class="m-0 text-dark"><label>{{ 'EditContractNumberConfig_title' | translate}}</label></h1>
            </div>
            <div class="col-md-auto ml-auto">
                <button class="btn btn-outline-primary d-inline-flex mr-3" (click)="cancel()">
                    <span class="material-icons-outlined mr-1">
                        clear
                    </span>{{ 'btn_cancel' | translate }}</button>
                <button class="btn btn-primary d-inline-flex" (click)="save()">
                    <span class="material-icons mr-1">
                        save
                    </span>{{ 'btn_save' | translate }}</button>
            </div>
        </div>
    </div>
</div>

<section class="content">
    <div class="container-fluid">
        <div class="bg-white">
            <section class="p-3">

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ 'ListContractNumberConfig_label_filter' | translate }} <span class="text-danger">*</span></label>
                            <ng-select [(ngModel)]="action" [items]="actionOptions" bindValue="value"
                                [searchable]="false" [clearable]="false">
                                <ng-template ng-label-tmp let-item="item">
                                    <span>{{ item.label | translate }}</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <span>{{ item.label | translate }}</span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ 'status' | translate }} <span class="text-danger">*</span></label>
                            <ng-select [formControl]="disable" [items]="disableOptions" bindValue="value"
                                [searchable]="false" [clearable]="false" (change)="changeStatus($event)">
                                <ng-template ng-label-tmp let-item="item">
                                    <span>{{ item.label | translate }}</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <span>{{ item.label | translate }}</span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div *ngIf="originConfigDefault == false" class="row">
                    <div class="col-md-4">
                        <div class="icheck-primary mb-3" style="width: fit-content;">
                            <input [checked]="configDefault" type="checkbox"
                                id="checkboxPrimary-configDefault"
                                (change)="changeCheckConfigDefault()" [disabled]="disable.value">
                            <label for="checkboxPrimary-configDefault">
                                {{ 'ContractNumberConfig_setDefault' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
                <div *ngIf="originConfigDefault == true" class="row">
                    <div class="col-md-4">
                        <span class="font-italic text-black">{{ 'ContractNumberDetail_isDefault' | translate }}</span>
                    </div>
                </div>

            </section>

            <section class="p-3">
                <label class="text-primary">{{ 'AddContractNumberConfig_struct' | translate }}</label>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ 'AddContractNumberConfig_simulation' | translate }}</label>
                            <input class="form-control" [(ngModel)]="cncSimulator" type="text" disabled>
                        </div>
                    </div>
                </div>
                <div class="table-responsive enable-scroll">
                    <table class="table table-bordered mb-0">
                        <thead>
                            <tr class="bg-tb-header border-top text-left">
                                <th style="min-width: 30px; text-align: center;">{{ 'AddContractNumberConfig_table_header_1' | translate }}</th>
                                <th style="min-width: 230px;">{{ 'AddContractNumberConfig_table_header_2' | translate }}</th>
                                <th style="min-width: 220px;">{{ 'AddContractNumberConfig_table_header_3' | translate }}</th>
                                <th style="min-width: 450px;">{{ 'AddContractNumberConfig_table_header_4' | translate }}</th>
                                <th style="min-width: 40px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of sequenceLine; let i = index">
                                <td style="text-align: center;"><span *ngIf="item.sequence < 10">0</span>{{
                                    item.sequence }}</td>
                                <td>
                                    <ng-select appendTo="body" [(ngModel)]="item.suffixType" [items]="ingredientOptions"
                                        bindValue="value" [searchable]="false" [clearable]="false"
                                        (change)="changeSuffixType(item.sequence, item.suffixType); cncSimulcast()">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item.label | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item.label | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                </td>
                                <td>
                                    <ng-select *ngIf="i < sequenceLine.length - 1" appendTo="body"
                                        [(ngModel)]="sequenceLine[i + 1].prefixType" [items]="separatorOptions" bindValue="value"
                                        [searchable]="false" [clearable]="false" (change)="cncSimulcast()">
                                        <ng-template ng-label-tmp let-item="item">
                                            <span>{{ item.label | translate }}</span>
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span>{{ item.label | translate }}</span>
                                        </ng-template>
                                    </ng-select>
                                </td>
                                <td>
                                    <!-- NUMBER -->
                                    <div *ngIf="item.suffixType == 'NUMBER'">
                                        <div class="td-container">
                                            <span>{{ 'AddContractNumberConfig_have' | translate }}</span>
                                            &nbsp; <div style="max-width: 100px;">
                                                <ng-select style="min-width: 60px;" appendTo="body" [searchable]="false"
                                                    [clearable]="false" [(ngModel)]="item.padding"
                                                    [items]="paddingOptions" bindValue="value" bindLabel="label"
                                                    (change)="changePadding(item.sequence, item.padding); cncSimulcast()">
                                                </ng-select>
                                            </div> &nbsp; <span>{{ 'AddContractNumberConfig_number_format' | translate }} </span> &nbsp;
                                            <div>
                                                <ng-select style="min-width: 150px;" [(ngModel)]="item.startNumber"
                                                    [searchable]="false" appendTo="body" [clearable]="false"
                                                    [items]="startNumberFormat[i]" bindValue="value" bindLabel="label"
                                                    (change)="cncSimulcast()">

                                                </ng-select>

                                            </div>
                                        </div>
                                        <div class="td-container mt-2">
                                            <span>{{ 'AddContractNumberConfig_auto_reset' | translate }}</span>
                                            &nbsp; <div>
                                                <ng-select style="min-width: 150px;" [items]="resetTypeOptions"
                                                    appendTo="body" bindValue="value"
                                                    [(ngModel)]="item.resetType" [searchable]="false"
                                                    [clearable]="false">
                                                    <ng-template ng-label-tmp let-item="item">
                                                        <span>{{ item.label | translate }}</span>
                                                    </ng-template>
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <span>{{ item.label | translate }}</span>
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- VARIABLE -->
                                    <div *ngIf="item.suffixType == 'VARIABLE'">
                                        <ng-select appendTo="body" [(ngModel)]="item.suffix"
                                            [items]="variableOptions" bindValue="value"
                                            [searchable]="false" [clearable]="false" (change)="cncSimulcast()">
                                            <ng-template ng-label-tmp let-item="item">
                                                <span>{{ item.label | translate }}</span>
                                            </ng-template>
                                            <ng-template ng-option-tmp let-item="item">
                                                <span>{{ item.label | translate }}</span>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                    <!-- STRING -->
                                    <div *ngIf="item.suffixType == 'STRING'">
                                        <input [(ngModel)]="item.suffix" class="form-control" type="text" (keyup)="cncSimulcast()">
                                    </div>
                                </td>
                                <td style="text-align: center;">
                                    <a style="cursor: pointer;" (click)="removeIngredient(i)" class="text-primary text-decoration-underline">{{ 'btn_delete' | translate }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-3">
                    <a style="cursor: pointer;" (click)="addIngredient()"
                        class="text-primary text-decoration-underline">+ {{ 'btn_addnew' | translate }}</a>
                </div>
            </section>
        </div>
    </div>
</section>